import { render, staticRenderFns } from "./Paimaigonggao.vue?vue&type=template&id=6ce45f7e&"
import script from "./Paimaigonggao.vue?vue&type=script&lang=js&"
export * from "./Paimaigonggao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports